<div [ngClass]="collapse ? 'ap-filter-tree-items-hidden' : ''" class="ap-filter-cc ap-filter-tree-items">
	<div class="">
		<mat-checkbox (change)="setAll($event.checked); onChange();"
			[(ngModel)]="subControl.subOptions ? isAllChecked : subControl.activated" [indeterminate]="someComplete()"
			color="primary" [ngClass]="collapse ? 'ap-filter-checkbox-hide' : ''"
			class="f-filter-checkbox text-base mx-1">
			<span class="uppercase ap-filter-header">{{ subControl.name }}</span>
		</mat-checkbox>
		<div (click)="toggleCollapseSubTree()" *ngIf="subControl.subOptions">
			<span *ngIf="collapseSubTree" class="cursor-pointer">
				<span class="plus_minus_icon plus material-symbols-outlined">add</span>
			</span>
			<span *ngIf="!collapseSubTree" class="cursor-pointer">
				<span class="plus_minus_icon plus material-symbols-outlined">remove</span>
			</span>
		</div>
	</div>
	<div  [ngClass]="collapse ? 'filter_option_inner' : 'filter_option_inner active'">
		<ul *ngIf="subControl.subOptions" [ngClass]="collapseSubTree ? 'ap-filter-tree-items-hidden' : ''"
			class="ap-filter-cc ap-filter-tree-items">
			<li *ngFor="let subSubControl of subControl.subOptions">
				<mat-checkbox (change)="onChange()" (ngModelChange)="updateAllComplete()"
					[(ngModel)]="subSubControl.activated" [ngClass]="collapseSubTree ? 'f-filter-checkbox-hide' : ''"
					class="f-filter-checkbox mx-4">
					<span class="uppercase text-[0.9rem]">{{subSubControl.name}}</span>
				</mat-checkbox>
			</li>
		</ul>
	</div>
</div>
